import { Text } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { formatDate } from '../utils/formatDate';

type Props = {
  subscriptionEndDate: string;
};

export function Header({ subscriptionEndDate }: Props): JSX.Element {
  const { t } = useTranslation('voluntary-churn');

  const date = formatDate(subscriptionEndDate);

  return (
    <>
      <Text as="h1" textType="header4">
        {t('churn.deflection-modal.title')}
      </Text>
      <div>
        <Text
          textType="body2"
          dangerouslySetInnerHTML={{ __html: t('churn.deflection-modal.gratitude-subtitle') }}
        />
        <br />
        <Text
          textType="body2"
          dangerouslySetInnerHTML={{
            __html: t('churn.deflection-modal.churn-start-date-subtitle', {
              date: `<strong>${date}</strong>`,
            }),
          }}
        />
      </div>
    </>
  );
}
